export default "__VITE_ASSET__CGe3Xnx1__"